const DOC = document;

const WIN = window;

const Elements = function (options) {

	const CORE = {

		elements: null,

		isInViewport: function (el) {
			const rect = el.getBoundingClientRect();
			const wh = (WIN.innerHeight || DOC.documentElement.clientHeight);
			const ww = (WIN.innerWidth || DOC.documentElement.clientWidth);

			return (
				((wh - rect.top) >= 0) &&
				((wh - rect.bottom) <= (wh)) &&
				((ww - rect.left) >= 0) &&
				((ww - rect.right) <= (ww))
			);

			// return (
			// 	rect.top >= 0 &&
			// 	rect.left >= 0 &&
			// 	rect.bottom <= (WIN.innerHeight || DOC.documentElement.clientHeight) &&
			// 	rect.right <= (WIN.innerWidth || DOC.documentElement.clientWidth)
			// );
		},

		onScroll: function (e) {
			var elements = CORE.elements;
			var i = 0;

			if (elements == null) {
				return;
			}

			for (i; i < elements.length; i++) {
				options.onElement(elements[i], CORE.isInViewport(elements[i]));
			}

		},

		interval: function (el) {
			var Int;

			Int = setInterval(function () {
				if (options.onElement(el, CORE.isInViewport(el))) {
					clearInterval(Int);
				}
			}, 300);

		},

		construct: function () {
			var els;
			var i = 0;

			if (typeof options !== 'object' || options == null || !('className' in options)) {
				return null;
			}

			if (!('onElement' in options) || typeof options.onElement !== 'function') {
				return null;
			}
			els = DOC.getElementsByClassName(options.className);

			if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
				return null;
			}
			CORE.elements = [];

			for (i; i < els.length; i++) {
				CORE.elements[CORE.elements.length] = els[i];
				CORE.interval(els[i]);

			}
			DOC.addEventListener('scroll', CORE.onScroll, { passive: true });

		},

		reload: function () {
			CORE.destroy();
			CORE.construct();

			return {
				elements: CORE.elements,
				reload: CORE.reload,
				destroy: CORE.destroy
			};
		},

		destroy: function () {
			DOC.removeEventListener('scroll', CORE.onScroll, { passive: true })
		}
	};

	CORE.construct();

	return {
		elements: CORE.elements,
		reload: CORE.reload,
		destroy: CORE.destroy
	}


};

export default Elements;


/**
 * Permet le lazy loading des produits
 */
//  (function (DOC, WIN) {

// 	var CORE = {

// 		elements: function (className, callback) {
// 			var els, i, elements, isFunction;

// 			if (typeof className !== 'string') {
// 				return null;
// 			}
// 			els = DOC.getElementsByClassName(className);

// 			if (!els || els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
// 				return null;
// 			}
// 			isFunction = typeof callback === 'function';
// 			elements = [];
// 			i = 0;

// 			for (i; i < els.length; i++){
// 				elements[elements.length] = els[i];

// 				if (isFunction) {
// 					callback(els[i]);
// 				}
// 			}

// 			return elements.length ? elements : null;
// 		},

// 		viewport: {

// 			isInViewport: function(el) {
// 				const rect = el.getBoundingClientRect();

// 				return (
// 					rect.top >= 0 &&
// 					rect.left >= 0 &&
// 					rect.bottom <= (WIN.innerHeight || DOC.documentElement.clientHeight) &&
// 					rect.right <= (WIN.innerWidth || DOC.documentElement.clientWidth)

// 				);
// 			},

// 			onScroll: function (e) {
// 				var elements = CORE.products.elements;
// 				var i = 0;

// 				if (elements == null) {
// 					return;
// 				}

// 				for (i; i < elements.length; i++){
// 					CORE.products.load(elements[i]);
// 				}

// 			},

// 			construct: function () {

// 				if (CORE.products.elements === null) {
// 					CORE.products.construct();
// 				}

// 				if (CORE.products.elements === null) {
// 					return;
// 				}
// 				DOC.addEventListener('scroll', CORE.viewport.onScroll, {passive: true});
// 			}

// 		},

// 		products: {
// 			className: 'prd--lazy-loading',

// 			elements: null,

// 			ajax: function (el) {

// 				el.FreevoxPrdIsLoading = true;

// 				$.ajax({
// 					url: '/ajax/product.php',
// 					data: {
// 						prd: el.dataset.prd,
// 						type: $(el).hasClass(CORE.products.className + '--inlist') ? 'list' : 'grid'
// 					},
// 					type: 'GET',
// 					dataType: 'json',
// 				}).done(function (res) {

// 					if (typeof res !== 'object' || !('error' in res) || !('content' in res)) {
// 						return;
// 					}

// 					if (res.error != 0 || typeof res.content !== 'string' || !res.content.length) {
// 						return;
// 					}
// 					$(el).replaceWith(res.content);
// 					updateSpinners();
// 					CORE.products.construct();

// 				});

// 			},

// 			load: function (el) {

// 				if ('FreevoxPrdIsLoading' in el && el.FreevoxPrdIsLoading) {
// 					return;
// 				}

// 				if (CORE.viewport.isInViewport(el)) {
// 					CORE.products.ajax(el);
// 				}

// 			},

// 			onProduct: function (el) {

// 				setInterval(function () {
// 					CORE.products.load(el)
// 				}, 300);

// 			},

// 			construct: function () {
// 				CORE.products.elements = CORE.elements(CORE.products.className, CORE.products.onProduct);

// 			}

// 		}

// 	};
// 	CORE.products.construct();
// 	CORE.viewport.construct();

// })(document, window);